import { useQuery } from '@apollo/client';
import GET_CURRENT_TENANT from 'api/queries/GET_CURRENT_TENANT';
import Loader from 'common/Loader';
import React, { createContext } from 'react';
import { Redirect } from 'react-router';

export const TenantContext = createContext({});

const OrganizationAccessRoute = ({ children }) => {
  const { data, error, loading } = useQuery(GET_CURRENT_TENANT, {
    fetchPolicy: 'network-only',
  });

  if (loading) {
    return <Loader />;
  }

  return data?.me?.currentTenant ? (
    <TenantContext.Provider value={data}>{children}</TenantContext.Provider>
  ) : error ? (
    <Redirect to="/login" />
  ) : (
    <Redirect to="/no-organization" />
  );
};

export default OrganizationAccessRoute;
